import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
// import { DashboardParentGuard } from 'src/app/shared/guards/dashboard-parent.guard';
// import { DashboardTeacherGuard } from 'src/app/shared/guards/dashboard-teacher.guard';
// import {DashboardStudentGuard} from '../../../../shared/guards/dashboard-student.guard';
// import {TaskGuard} from '../../../../shared/guards/task.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'admin',
        loadChildren: () =>
          import('./dashboard-admin/dashboard-admin.module').then(
            (m) => m.DashboardAdminModule
          ),
      },
      {
        path: 'student',
        loadChildren: () =>
          import('./dashboard-student/dashboard-student.module').then(
            (m) => m.DashboardStudentModule
          ),
      },
    ],
  },
 
  // {
  //   path: 'student',
  //   // canActivate: [DashboardStudentGuard],
  //   loadChildren: () => import('./dashboard-student/dashboard-student.module').then(m => m.DashboardStudentModule)
  // },
  // {
  //   path: 'teacher',
  //   // canActivate: [DashboardTeacherGuard],
  //   loadChildren: () => import('./dashboard-teacher/dashboard-teacher.module').then(m => m.DashboardTeacherModule)
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DashboardRoutingModule {
}
